'use strict';

export {};


export type ToJsonResult = {
    type? : never;
    name : string;
    doNotLocalize? : boolean;
    message? : string;
    monoSpaceMessage? : boolean;
    doNotLocalizeMessage? : never;
    number? : number;
    placeholders? : never;
    severity? : 'error' | 'warning';
    position? : string | { line : number; column : number };
    errors? : never;
};

declare global {
    interface Error {
        severity? : 'error' | 'warning';
        number? : number;
        position? : string | {
            line : number;
            column : number;
        };
        monoSpaceMessage? : boolean;

        toJSON() : ToJsonResult;

        toString() : string;

        toHTML() : string;
    }

    interface ErrorConstructor {
        fromJSON( data : ToJsonResult ) : Error
    }
}

Error.prototype.toJSON = function() : ToJsonResult {
    const retVal : ToJsonResult = {
        name: this.name
    };

    if ( this.message && this.message !== this.name ) {
        retVal.message = this.message;

        if ( this.monoSpaceMessage ) {
            retVal.monoSpaceMessage = this.monoSpaceMessage;
        }
    }

    if ( this.number !== undefined ) {
        retVal.number = this.number;
    }

    if ( this.position !== undefined ) {
        retVal.position = this.position;
    }
    else {
        let position = this.stack?.split( '\n' )[ 1 ] ?? '';

        if ( position ) {
            if ( position.indexOf( '(' ) !== -1 ) {
                position = position.replace( /^.* (.*) \(.*:(.*):(\d*):\d*\)$/, 'at $2 ($1), line: $3' );
            }
            else {
                position = position.replace( /^.* \/?.*:(.*):(\d*):\d*$/, 'at $1, line: $2' );
            }

            retVal.position = position.trim();
        }
    }

    if ( this.severity ) {
        retVal.severity = this.severity;
    }

    return retVal;
}

Error.prototype.toString = function() : string {
    let retVal = '';

    if ( this.name ) {
        retVal += this.name;
    }

    if ( this.message && this.message !== this.name ) {
        //retVal += `\n${''.indent()}${this.message.split( '\n' ).join( '\n' + ''.indent() )}`;
        retVal += `\n${this.message}`;
    }

    if ( this.position ) {
        if ( typeof this.position === 'string' ) {
            retVal += `\n${this.position.indent()}`;
        }
        else {
            retVal += '\n' + `line:   ${this.position.line}`.indent();
            retVal += '\n' + `column: ${this.position.column}`.indent();
        }
    }
    else {
        let position = this.stack?.split( '\n' )[ 1 ] ?? '';

        if ( position ) {
            if ( position.indexOf( '(' ) !== -1 ) {
                position = position.replace( /^.* (.*) \(.*:(.*):(\d*):\d*\)$/, 'at $2 ($1), line: $3' );
            }
            else {
                position = position.replace( /^.* \/?.*:(.*):(\d*):\d*$/, 'at $1, line: $2' );
            }

            retVal += `\n${position.trim()}`;
        }
    }

    return retVal;
}

Error.prototype.toHTML = function() : string {
    let retVal = '';

    retVal += '<div class="yn-error-subtitle">';
    retVal += this.name;
    retVal += '</div>';

    if ( this.message && this.message !== this.name ) {
        if ( this.monoSpaceMessage ) {
            retVal += '<div class="yn-error-message-monospace">';
        }
        else {
            retVal += '<div class="yn-error-message">';
        }

        let message = this.message.replace( '<', '&lt;' )
                          .replace( '>', '&gt;' )
                          .replace( /\r?\n/g, '<br/>' );

        if ( this.monoSpaceMessage ) {
            message = message.replace( / /g, '&nbsp;' )
                             .replace( /\^/g, '<div class="yn-error-position-marker fas fa-arrow-up"></div>' );
        }

        retVal += message;
        retVal += '</div>';
    }

    if ( this.position ) {
        retVal += '<div class="yn-error-position">';
        if ( typeof this.position === 'string' ) {
            retVal += this.position;
        }
        else {
            retVal += `line:   ${this.position.line}`;
            retVal += `<br/>column: ${this.position.column}`;
        }
        retVal += '</div>';
    }

    return retVal;
}

Error.fromJSON = function( data : ToJsonResult ) : Error {
    const retVal = new Error( data.message ?? data.name );

    if ( data.message && data.message !== data.name ) {
        retVal.name = data.name;

        if ( data.monoSpaceMessage ) {
            retVal.monoSpaceMessage = data.monoSpaceMessage;
        }
    }

    if ( data.number !== undefined ) {
        retVal.number = data.number;
    }

    if ( data.position !== undefined ) {
        retVal.position = data.position;
    }

    if ( data.severity ) {
        retVal.severity = data.severity;
    }

    return retVal;
}
